import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './TypeBlock.module.sass';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';

function TypeBlock(props) {
  const {
    onClick, text, isActive, color, editable, onChange, className,
  } = props;

  const inputRef = useRef(null);

  const onInputChange = (event) => {
    onChange(event.target.value);
  };

  const onClickHandler = () => {
    if (!editable && !onClick) { return; }

    if (!editable) {
      onClick();
      return;
    }

    if (onClick) {
      onClick();
    }

    inputRef.current.focus();
  };

  const style = {
    borderColor: color,
  };

  if (isActive) {
    style.background = color;
  }

  return (
    <ClickableDiv
      className={`${styles.block} ${isActive && styles.active} ${className}`}
      onClick={onClickHandler}
      style={style}
    >
      {!editable && text}
      {editable && (
        <input type="text" ref={inputRef} placeholder="Other, Type Here" value={text} onChange={onInputChange} />
      )}
    </ClickableDiv>
  );
}

TypeBlock.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default TypeBlock;
